import { g as rt } from "./get-BqrHaTdZ.js";
import { t as Ee, a as yt, e as Fe, f as Ie, h as oe, i as ce, j as vt } from "./en-US-DzLLmR2o.js";
import { d as _t } from "./differenceInCalendarDays-BtfJmFUw.js";
import { c as bt, g as xt, a as wt, b as kt, d as Tt, l as St, i as Ot, e as Mt, w as At } from "./protectedTokens-CpdGM6ML.js";
import { a as w } from "./addLeadingZeros-DEhn_sgb.js";
function jt(r) {
  return r instanceof Date || typeof r == "object" && Object.prototype.toString.call(r) === "[object Date]";
}
function Ct(r) {
  if (!jt(r) && typeof r != "number")
    return !1;
  const e = Ee(r);
  return !isNaN(Number(e));
}
function Nt(r) {
  const e = Ee(r), t = bt(r, 0);
  return t.setFullYear(e.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Et(r) {
  const e = Ee(r);
  return _t(e, Nt(e)) + 1;
}
const z = {
  // Year
  y(r, e) {
    const t = r.getFullYear(), n = t > 0 ? t : 1 - t;
    return w(e === "yy" ? n % 100 : n, e.length);
  },
  // Month
  M(r, e) {
    const t = r.getMonth();
    return e === "M" ? String(t + 1) : w(t + 1, 2);
  },
  // Day of the month
  d(r, e) {
    return w(r.getDate(), e.length);
  },
  // AM or PM
  a(r, e) {
    const t = r.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(r, e) {
    return w(r.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(r, e) {
    return w(r.getHours(), e.length);
  },
  // Minute
  m(r, e) {
    return w(r.getMinutes(), e.length);
  },
  // Second
  s(r, e) {
    return w(r.getSeconds(), e.length);
  },
  // Fraction of second
  S(r, e) {
    const t = e.length, n = r.getMilliseconds(), s = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return w(s, e.length);
  }
}, ee = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Be = {
  // Era
  G: function(r, e, t) {
    const n = r.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(r, e, t) {
    if (e === "yo") {
      const n = r.getFullYear(), s = n > 0 ? n : 1 - n;
      return t.ordinalNumber(s, { unit: "year" });
    }
    return z.y(r, e);
  },
  // Local week-numbering year
  Y: function(r, e, t, n) {
    const s = Tt(r, n), a = s > 0 ? s : 1 - s;
    if (e === "YY") {
      const i = a % 100;
      return w(i, 2);
    }
    return e === "Yo" ? t.ordinalNumber(a, { unit: "year" }) : w(a, e.length);
  },
  // ISO week-numbering year
  R: function(r, e) {
    const t = kt(r);
    return w(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(r, e) {
    const t = r.getFullYear();
    return w(t, e.length);
  },
  // Quarter
  Q: function(r, e, t) {
    const n = Math.ceil((r.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return w(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(r, e, t) {
    const n = Math.ceil((r.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return w(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(r, e, t) {
    const n = r.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return z.M(r, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(r, e, t) {
    const n = r.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return w(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(r, e, t, n) {
    const s = wt(r, n);
    return e === "wo" ? t.ordinalNumber(s, { unit: "week" }) : w(s, e.length);
  },
  // ISO week of year
  I: function(r, e, t) {
    const n = xt(r);
    return e === "Io" ? t.ordinalNumber(n, { unit: "week" }) : w(n, e.length);
  },
  // Day of the month
  d: function(r, e, t) {
    return e === "do" ? t.ordinalNumber(r.getDate(), { unit: "date" }) : z.d(r, e);
  },
  // Day of year
  D: function(r, e, t) {
    const n = Et(r);
    return e === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : w(n, e.length);
  },
  // Day of week
  E: function(r, e, t) {
    const n = r.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(r, e, t, n) {
    const s = r.getDay(), a = (s - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return w(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(a, { unit: "day" });
      case "eee":
        return t.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(r, e, t, n) {
    const s = r.getDay(), a = (s - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return w(a, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return t.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(r, e, t) {
    const n = r.getDay(), s = n === 0 ? 7 : n;
    switch (e) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return w(s, e.length);
      // 2nd
      case "io":
        return t.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(r, e, t) {
    const s = r.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(r, e, t) {
    const n = r.getHours();
    let s;
    switch (n === 12 ? s = ee.noon : n === 0 ? s = ee.midnight : s = n / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(r, e, t) {
    const n = r.getHours();
    let s;
    switch (n >= 17 ? s = ee.evening : n >= 12 ? s = ee.afternoon : n >= 4 ? s = ee.morning : s = ee.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(r, e, t) {
    if (e === "ho") {
      let n = r.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return z.h(r, e);
  },
  // Hour [0-23]
  H: function(r, e, t) {
    return e === "Ho" ? t.ordinalNumber(r.getHours(), { unit: "hour" }) : z.H(r, e);
  },
  // Hour [0-11]
  K: function(r, e, t) {
    const n = r.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : w(n, e.length);
  },
  // Hour [1-24]
  k: function(r, e, t) {
    let n = r.getHours();
    return n === 0 && (n = 24), e === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : w(n, e.length);
  },
  // Minute
  m: function(r, e, t) {
    return e === "mo" ? t.ordinalNumber(r.getMinutes(), { unit: "minute" }) : z.m(r, e);
  },
  // Second
  s: function(r, e, t) {
    return e === "so" ? t.ordinalNumber(r.getSeconds(), { unit: "second" }) : z.s(r, e);
  },
  // Fraction of second
  S: function(r, e) {
    return z.S(r, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(r, e, t) {
    const n = r.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return Je(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return H(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return H(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return Je(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return H(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return H(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ue(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + H(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ue(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + H(n, ":");
    }
  },
  // Seconds timestamp
  t: function(r, e, t) {
    const n = Math.trunc(r.getTime() / 1e3);
    return w(n, e.length);
  },
  // Milliseconds timestamp
  T: function(r, e, t) {
    const n = r.getTime();
    return w(n, e.length);
  }
};
function Ue(r, e = "") {
  const t = r > 0 ? "-" : "+", n = Math.abs(r), s = Math.trunc(n / 60), a = n % 60;
  return a === 0 ? t + String(s) : t + String(s) + e + w(a, 2);
}
function Je(r, e) {
  return r % 60 === 0 ? (r > 0 ? "-" : "+") + w(Math.abs(r) / 60, 2) : H(r, e);
}
function H(r, e = "") {
  const t = r > 0 ? "-" : "+", n = Math.abs(r), s = w(Math.trunc(n / 60), 2), a = w(n % 60, 2);
  return t + s + e + a;
}
const Pt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Rt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, It = /^'([^]*?)'?$/, Zt = /''/g, Dt = /[a-zA-Z]/;
function Lt(r, e, t) {
  var p, k, x, I, J, Y, N, ke;
  const n = yt(), s = (t == null ? void 0 : t.locale) ?? n.locale ?? Fe, a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((k = (p = t == null ? void 0 : t.locale) == null ? void 0 : p.options) == null ? void 0 : k.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((I = (x = n.locale) == null ? void 0 : x.options) == null ? void 0 : I.firstWeekContainsDate) ?? 1, i = (t == null ? void 0 : t.weekStartsOn) ?? ((Y = (J = t == null ? void 0 : t.locale) == null ? void 0 : J.options) == null ? void 0 : Y.weekStartsOn) ?? n.weekStartsOn ?? ((ke = (N = n.locale) == null ? void 0 : N.options) == null ? void 0 : ke.weekStartsOn) ?? 0, o = Ee(r);
  if (!Ct(o))
    throw new RangeError("Invalid time value");
  let u = e.match(Rt).map((j) => {
    const A = j[0];
    if (A === "p" || A === "P") {
      const Re = St[A];
      return Re(j, s.formatLong);
    }
    return j;
  }).join("").match(Pt).map((j) => {
    if (j === "''")
      return { isToken: !1, value: "'" };
    const A = j[0];
    if (A === "'")
      return { isToken: !1, value: $t(j) };
    if (Be[A])
      return { isToken: !0, value: j };
    if (A.match(Dt))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + A + "`"
      );
    return { isToken: !1, value: j };
  });
  s.localize.preprocessor && (u = s.localize.preprocessor(o, u));
  const d = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: s
  };
  return u.map((j) => {
    if (!j.isToken) return j.value;
    const A = j.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Ot(A) || !(t != null && t.useAdditionalDayOfYearTokens) && Mt(A)) && At(A, e, String(r));
    const Re = Be[A[0]];
    return Re(o, A, s.localize, d);
  }).join("");
}
function $t(r) {
  const e = r.match(It);
  return e ? e[1].replace(Zt, "'") : r;
}
var b;
(function(r) {
  r.assertEqual = (s) => {
  };
  function e(s) {
  }
  r.assertIs = e;
  function t(s) {
    throw new Error();
  }
  r.assertNever = t, r.arrayToEnum = (s) => {
    const a = {};
    for (const i of s)
      a[i] = i;
    return a;
  }, r.getValidEnumValues = (s) => {
    const a = r.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), i = {};
    for (const o of a)
      i[o] = s[o];
    return r.objectValues(i);
  }, r.objectValues = (s) => r.objectKeys(s).map(function(a) {
    return s[a];
  }), r.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const a = [];
    for (const i in s)
      Object.prototype.hasOwnProperty.call(s, i) && a.push(i);
    return a;
  }, r.find = (s, a) => {
    for (const i of s)
      if (a(i))
        return i;
  }, r.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && Number.isFinite(s) && Math.floor(s) === s;
  function n(s, a = " | ") {
    return s.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  r.joinValues = n, r.jsonStringifyReplacer = (s, a) => typeof a == "bigint" ? a.toString() : a;
})(b || (b = {}));
var Le;
(function(r) {
  r.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(Le || (Le = {}));
const h = b.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), W = (r) => {
  switch (typeof r) {
    case "undefined":
      return h.undefined;
    case "string":
      return h.string;
    case "number":
      return Number.isNaN(r) ? h.nan : h.number;
    case "boolean":
      return h.boolean;
    case "function":
      return h.function;
    case "bigint":
      return h.bigint;
    case "symbol":
      return h.symbol;
    case "object":
      return Array.isArray(r) ? h.array : r === null ? h.null : r.then && typeof r.then == "function" && r.catch && typeof r.catch == "function" ? h.promise : typeof Map < "u" && r instanceof Map ? h.map : typeof Set < "u" && r instanceof Set ? h.set : typeof Date < "u" && r instanceof Date ? h.date : h.object;
    default:
      return h.unknown;
  }
}, l = b.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Wt = (r) => JSON.stringify(r, null, 2).replace(/"([^"]+)":/g, "$1:");
class C extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(a) {
      return a.message;
    }, n = { _errors: [] }, s = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(s);
        else if (i.code === "invalid_return_type")
          s(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          s(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(t(i));
        else {
          let o = n, u = 0;
          for (; u < i.path.length; ) {
            const d = i.path[u];
            u === i.path.length - 1 ? (o[d] = o[d] || { _errors: [] }, o[d]._errors.push(t(i))) : o[d] = o[d] || { _errors: [] }, o = o[d], u++;
          }
        }
    };
    return s(this), n;
  }
  static assert(e) {
    if (!(e instanceof C))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, b.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (t[s.path[0]] = t[s.path[0]] || [], t[s.path[0]].push(e(s))) : n.push(e(s));
    return { formErrors: n, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
C.create = (r) => new C(r);
const ae = (r, e) => {
  let t;
  switch (r.code) {
    case l.invalid_type:
      r.received === h.undefined ? t = "Required" : t = `Expected ${r.expected}, received ${r.received}`;
      break;
    case l.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(r.expected, b.jsonStringifyReplacer)}`;
      break;
    case l.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${b.joinValues(r.keys, ", ")}`;
      break;
    case l.invalid_union:
      t = "Invalid input";
      break;
    case l.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${b.joinValues(r.options)}`;
      break;
    case l.invalid_enum_value:
      t = `Invalid enum value. Expected ${b.joinValues(r.options)}, received '${r.received}'`;
      break;
    case l.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case l.invalid_return_type:
      t = "Invalid function return type";
      break;
    case l.invalid_date:
      t = "Invalid date";
      break;
    case l.invalid_string:
      typeof r.validation == "object" ? "includes" in r.validation ? (t = `Invalid input: must include "${r.validation.includes}"`, typeof r.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${r.validation.position}`)) : "startsWith" in r.validation ? t = `Invalid input: must start with "${r.validation.startsWith}"` : "endsWith" in r.validation ? t = `Invalid input: must end with "${r.validation.endsWith}"` : b.assertNever(r.validation) : r.validation !== "regex" ? t = `Invalid ${r.validation}` : t = "Invalid";
      break;
    case l.too_small:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "more than"} ${r.minimum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "over"} ${r.minimum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${r.minimum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(r.minimum))}` : t = "Invalid input";
      break;
    case l.too_big:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "less than"} ${r.maximum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "under"} ${r.maximum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "bigint" ? t = `BigInt must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly" : r.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(r.maximum))}` : t = "Invalid input";
      break;
    case l.custom:
      t = "Invalid input";
      break;
    case l.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case l.not_multiple_of:
      t = `Number must be a multiple of ${r.multipleOf}`;
      break;
    case l.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, b.assertNever(r);
  }
  return { message: t };
};
let nt = ae;
function Vt(r) {
  nt = r;
}
function Oe() {
  return nt;
}
const Me = (r) => {
  const { data: e, path: t, errorMaps: n, issueData: s } = r, a = [...t, ...s.path || []], i = {
    ...s,
    path: a
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: a,
      message: s.message
    };
  let o = "";
  const u = n.filter((d) => !!d).slice().reverse();
  for (const d of u)
    o = d(i, { data: e, defaultError: o }).message;
  return {
    ...s,
    path: a,
    message: o
  };
}, zt = [];
function f(r, e) {
  const t = Oe(), n = Me({
    issueData: e,
    data: r.data,
    path: r.path,
    errorMaps: [
      r.common.contextualErrorMap,
      // contextual error map is first priority
      r.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === ae ? void 0 : ae
      // then global default map
    ].filter((s) => !!s)
  });
  r.common.issues.push(n);
}
class O {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const n = [];
    for (const s of t) {
      if (s.status === "aborted")
        return g;
      s.status === "dirty" && e.dirty(), n.push(s.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, t) {
    const n = [];
    for (const s of t) {
      const a = await s.key, i = await s.value;
      n.push({
        key: a,
        value: i
      });
    }
    return O.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, t) {
    const n = {};
    for (const s of t) {
      const { key: a, value: i } = s;
      if (a.status === "aborted" || i.status === "aborted")
        return g;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value < "u" || s.alwaysSet) && (n[a.value] = i.value);
    }
    return { status: e.value, value: n };
  }
}
const g = Object.freeze({
  status: "aborted"
}), re = (r) => ({ status: "dirty", value: r }), M = (r) => ({ status: "valid", value: r }), $e = (r) => r.status === "aborted", We = (r) => r.status === "dirty", G = (r) => r.status === "valid", ue = (r) => typeof Promise < "u" && r instanceof Promise;
var m;
(function(r) {
  r.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, r.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(m || (m = {}));
class D {
  constructor(e, t, n, s) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Ye = (r, e) => {
  if (G(e))
    return { success: !0, data: e.value };
  if (!r.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new C(r.common.issues);
      return this._error = t, this._error;
    }
  };
};
function v(r) {
  if (!r)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: n, description: s } = r;
  if (e && (t || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (i, o) => {
    const { message: u } = r;
    return i.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: u ?? n ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: u ?? t ?? o.defaultError };
  }, description: s };
}
class _ {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return W(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: W(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new O(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: W(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (ue(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const n = this.safeParse(e, t);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, t) {
    const n = {
      common: {
        issues: [],
        async: (t == null ? void 0 : t.async) ?? !1,
        contextualErrorMap: t == null ? void 0 : t.errorMap
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: W(e)
    }, s = this._parseSync({ data: e, path: n.path, parent: n });
    return Ye(n, s);
  }
  "~validate"(e) {
    var n, s;
    const t = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: W(e)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: e, path: [], parent: t });
        return G(a) ? {
          value: a.value
        } : {
          issues: t.common.issues
        };
      } catch (a) {
        (s = (n = a == null ? void 0 : a.message) == null ? void 0 : n.toLowerCase()) != null && s.includes("encountered") && (this["~standard"].async = !0), t.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: t }).then((a) => G(a) ? {
      value: a.value
    } : {
      issues: t.common.issues
    });
  }
  async parseAsync(e, t) {
    const n = await this.safeParseAsync(e, t);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, t) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: t == null ? void 0 : t.errorMap,
        async: !0
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: W(e)
    }, s = this._parse({ data: e, path: n.path, parent: n }), a = await (ue(s) ? s : Promise.resolve(s));
    return Ye(n, a);
  }
  refine(e, t) {
    const n = (s) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(s) : t;
    return this._refinement((s, a) => {
      const i = e(s), o = () => a.addIssue({
        code: l.custom,
        ...n(s)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((u) => u ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((n, s) => e(n) ? !0 : (s.addIssue(typeof t == "function" ? t(n, s) : t), !1));
  }
  _refinement(e) {
    return new R({
      schema: this,
      typeName: y.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return Z.create(this, this._def);
  }
  nullable() {
    return U.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return P.create(this);
  }
  promise() {
    return ie.create(this, this._def);
  }
  or(e) {
    return he.create([this, e], this._def);
  }
  and(e) {
    return me.create(this, e, this._def);
  }
  transform(e) {
    return new R({
      ...v(this._def),
      schema: this,
      typeName: y.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new _e({
      ...v(this._def),
      innerType: this,
      defaultValue: t,
      typeName: y.ZodDefault
    });
  }
  brand() {
    return new qe({
      typeName: y.ZodBranded,
      type: this,
      ...v(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new be({
      ...v(this._def),
      innerType: this,
      catchValue: t,
      typeName: y.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return we.create(this, e);
  }
  readonly() {
    return xe.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Ft = /^c[^\s-]{8,}$/i, qt = /^[0-9a-z]+$/, Bt = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Ut = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Jt = /^[a-z0-9_-]{21}$/i, Yt = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Ht = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Qt = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Gt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ze;
const Xt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Kt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, er = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, tr = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, rr = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, nr = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, at = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", ar = new RegExp(`^${at}$`);
function st(r) {
  let e = "[0-5]\\d";
  r.precision ? e = `${e}\\.\\d{${r.precision}}` : r.precision == null && (e = `${e}(\\.\\d+)?`);
  const t = r.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${t}`;
}
function sr(r) {
  return new RegExp(`^${st(r)}$`);
}
function it(r) {
  let e = `${at}T${st(r)}`;
  const t = [];
  return t.push(r.local ? "Z?" : "Z"), r.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function ir(r, e) {
  return !!((e === "v4" || !e) && Xt.test(r) || (e === "v6" || !e) && er.test(r));
}
function or(r, e) {
  if (!Yt.test(r))
    return !1;
  try {
    const [t] = r.split("."), n = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), s = JSON.parse(atob(n));
    return !(typeof s != "object" || s === null || "typ" in s && (s == null ? void 0 : s.typ) !== "JWT" || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function cr(r, e) {
  return !!((e === "v4" || !e) && Kt.test(r) || (e === "v6" || !e) && tr.test(r));
}
class E extends _ {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== h.string) {
      const a = this._getOrReturnCtx(e);
      return f(a, {
        code: l.invalid_type,
        expected: h.string,
        received: a.parsedType
      }), g;
    }
    const n = new O();
    let s;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (s = this._getOrReturnCtx(e, s), f(s, {
          code: l.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (s = this._getOrReturnCtx(e, s), f(s, {
          code: l.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "length") {
        const i = e.data.length > a.value, o = e.data.length < a.value;
        (i || o) && (s = this._getOrReturnCtx(e, s), i ? f(s, {
          code: l.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && f(s, {
          code: l.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), n.dirty());
      } else if (a.kind === "email")
        Qt.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "email",
          code: l.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "emoji")
        Ze || (Ze = new RegExp(Gt, "u")), Ze.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "emoji",
          code: l.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "uuid")
        Ut.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "uuid",
          code: l.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "nanoid")
        Jt.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "nanoid",
          code: l.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid")
        Ft.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "cuid",
          code: l.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid2")
        qt.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "cuid2",
          code: l.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "ulid")
        Bt.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "ulid",
          code: l.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), f(s, {
            validation: "url",
            code: l.invalid_string,
            message: a.message
          }), n.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "regex",
        code: l.invalid_string,
        message: a.message
      }), n.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: l.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), n.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: l.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: l.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "datetime" ? it(a).test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: l.invalid_string,
        validation: "datetime",
        message: a.message
      }), n.dirty()) : a.kind === "date" ? ar.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: l.invalid_string,
        validation: "date",
        message: a.message
      }), n.dirty()) : a.kind === "time" ? sr(a).test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: l.invalid_string,
        validation: "time",
        message: a.message
      }), n.dirty()) : a.kind === "duration" ? Ht.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "duration",
        code: l.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "ip" ? ir(e.data, a.version) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "ip",
        code: l.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "jwt" ? or(e.data, a.alg) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "jwt",
        code: l.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "cidr" ? cr(e.data, a.version) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "cidr",
        code: l.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64" ? rr.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "base64",
        code: l.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64url" ? nr.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "base64url",
        code: l.invalid_string,
        message: a.message
      }), n.dirty()) : b.assertNever(a);
    return { status: n.value, value: e.data };
  }
  _regex(e, t, n) {
    return this.refinement((s) => e.test(s), {
      validation: t,
      code: l.invalid_string,
      ...m.errToObj(n)
    });
  }
  _addCheck(e) {
    return new E({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...m.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...m.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...m.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...m.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...m.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...m.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...m.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...m.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...m.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...m.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...m.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...m.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...m.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...m.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...m.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...m.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...m.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t == null ? void 0 : t.position,
      ...m.errToObj(t == null ? void 0 : t.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...m.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...m.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...m.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...m.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...m.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, m.errToObj(e));
  }
  trim() {
    return new E({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new E({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new E({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
E.create = (r) => new E({
  checks: [],
  typeName: y.ZodString,
  coerce: (r == null ? void 0 : r.coerce) ?? !1,
  ...v(r)
});
function ur(r, e) {
  const t = (r.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, s = t > n ? t : n, a = Number.parseInt(r.toFixed(s).replace(".", "")), i = Number.parseInt(e.toFixed(s).replace(".", ""));
  return a % i / 10 ** s;
}
class F extends _ {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== h.number) {
      const a = this._getOrReturnCtx(e);
      return f(a, {
        code: l.invalid_type,
        expected: h.number,
        received: a.parsedType
      }), g;
    }
    let n;
    const s = new O();
    for (const a of this._def.checks)
      a.kind === "int" ? b.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: l.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), s.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: l.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: l.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? ur(e.data, a.value) !== 0 && (n = this._getOrReturnCtx(e, n), f(n, {
        code: l.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: l.not_finite,
        message: a.message
      }), s.dirty()) : b.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, m.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, m.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, m.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, m.toString(t));
  }
  setLimit(e, t, n, s) {
    return new F({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: n,
          message: m.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new F({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: m.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: m.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: m.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: m.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: m.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: m.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: m.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: m.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: m.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && b.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (t === null || n.value > t) && (t = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
F.create = (r) => new F({
  checks: [],
  typeName: y.ZodNumber,
  coerce: (r == null ? void 0 : r.coerce) || !1,
  ...v(r)
});
class q extends _ {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== h.bigint)
      return this._getInvalidInput(e);
    let n;
    const s = new O();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: l.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: l.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: l.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : b.assertNever(a);
    return { status: s.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return f(t, {
      code: l.invalid_type,
      expected: h.bigint,
      received: t.parsedType
    }), g;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, m.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, m.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, m.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, m.toString(t));
  }
  setLimit(e, t, n, s) {
    return new q({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: n,
          message: m.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new q({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: m.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: m.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: m.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: m.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: m.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
q.create = (r) => new q({
  checks: [],
  typeName: y.ZodBigInt,
  coerce: (r == null ? void 0 : r.coerce) ?? !1,
  ...v(r)
});
class de extends _ {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== h.boolean) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: l.invalid_type,
        expected: h.boolean,
        received: n.parsedType
      }), g;
    }
    return M(e.data);
  }
}
de.create = (r) => new de({
  typeName: y.ZodBoolean,
  coerce: (r == null ? void 0 : r.coerce) || !1,
  ...v(r)
});
class X extends _ {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== h.date) {
      const a = this._getOrReturnCtx(e);
      return f(a, {
        code: l.invalid_type,
        expected: h.date,
        received: a.parsedType
      }), g;
    }
    if (Number.isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return f(a, {
        code: l.invalid_date
      }), g;
    }
    const n = new O();
    let s;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (s = this._getOrReturnCtx(e, s), f(s, {
        code: l.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), n.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (s = this._getOrReturnCtx(e, s), f(s, {
        code: l.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), n.dirty()) : b.assertNever(a);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new X({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: m.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: m.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
X.create = (r) => new X({
  checks: [],
  coerce: (r == null ? void 0 : r.coerce) || !1,
  typeName: y.ZodDate,
  ...v(r)
});
class Ae extends _ {
  _parse(e) {
    if (this._getType(e) !== h.symbol) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: l.invalid_type,
        expected: h.symbol,
        received: n.parsedType
      }), g;
    }
    return M(e.data);
  }
}
Ae.create = (r) => new Ae({
  typeName: y.ZodSymbol,
  ...v(r)
});
class le extends _ {
  _parse(e) {
    if (this._getType(e) !== h.undefined) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: l.invalid_type,
        expected: h.undefined,
        received: n.parsedType
      }), g;
    }
    return M(e.data);
  }
}
le.create = (r) => new le({
  typeName: y.ZodUndefined,
  ...v(r)
});
class fe extends _ {
  _parse(e) {
    if (this._getType(e) !== h.null) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: l.invalid_type,
        expected: h.null,
        received: n.parsedType
      }), g;
    }
    return M(e.data);
  }
}
fe.create = (r) => new fe({
  typeName: y.ZodNull,
  ...v(r)
});
class se extends _ {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return M(e.data);
  }
}
se.create = (r) => new se({
  typeName: y.ZodAny,
  ...v(r)
});
class Q extends _ {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return M(e.data);
  }
}
Q.create = (r) => new Q({
  typeName: y.ZodUnknown,
  ...v(r)
});
class V extends _ {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return f(t, {
      code: l.invalid_type,
      expected: h.never,
      received: t.parsedType
    }), g;
  }
}
V.create = (r) => new V({
  typeName: y.ZodNever,
  ...v(r)
});
class je extends _ {
  _parse(e) {
    if (this._getType(e) !== h.undefined) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: l.invalid_type,
        expected: h.void,
        received: n.parsedType
      }), g;
    }
    return M(e.data);
  }
}
je.create = (r) => new je({
  typeName: y.ZodVoid,
  ...v(r)
});
class P extends _ {
  _parse(e) {
    const { ctx: t, status: n } = this._processInputParams(e), s = this._def;
    if (t.parsedType !== h.array)
      return f(t, {
        code: l.invalid_type,
        expected: h.array,
        received: t.parsedType
      }), g;
    if (s.exactLength !== null) {
      const i = t.data.length > s.exactLength.value, o = t.data.length < s.exactLength.value;
      (i || o) && (f(t, {
        code: i ? l.too_big : l.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: i ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && t.data.length < s.minLength.value && (f(t, {
      code: l.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && t.data.length > s.maxLength.value && (f(t, {
      code: l.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), t.common.async)
      return Promise.all([...t.data].map((i, o) => s.type._parseAsync(new D(t, i, t.path, o)))).then((i) => O.mergeArray(n, i));
    const a = [...t.data].map((i, o) => s.type._parseSync(new D(t, i, t.path, o)));
    return O.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new P({
      ...this._def,
      minLength: { value: e, message: m.toString(t) }
    });
  }
  max(e, t) {
    return new P({
      ...this._def,
      maxLength: { value: e, message: m.toString(t) }
    });
  }
  length(e, t) {
    return new P({
      ...this._def,
      exactLength: { value: e, message: m.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
P.create = (r, e) => new P({
  type: r,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: y.ZodArray,
  ...v(e)
});
function te(r) {
  if (r instanceof T) {
    const e = {};
    for (const t in r.shape) {
      const n = r.shape[t];
      e[t] = Z.create(te(n));
    }
    return new T({
      ...r._def,
      shape: () => e
    });
  } else return r instanceof P ? new P({
    ...r._def,
    type: te(r.element)
  }) : r instanceof Z ? Z.create(te(r.unwrap())) : r instanceof U ? U.create(te(r.unwrap())) : r instanceof L ? L.create(r.items.map((e) => te(e))) : r;
}
class T extends _ {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = b.objectKeys(e);
    return this._cached = { shape: e, keys: t }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== h.object) {
      const d = this._getOrReturnCtx(e);
      return f(d, {
        code: l.invalid_type,
        expected: h.object,
        received: d.parsedType
      }), g;
    }
    const { status: n, ctx: s } = this._processInputParams(e), { shape: a, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof V && this._def.unknownKeys === "strip"))
      for (const d in s.data)
        i.includes(d) || o.push(d);
    const u = [];
    for (const d of i) {
      const p = a[d], k = s.data[d];
      u.push({
        key: { status: "valid", value: d },
        value: p._parse(new D(s, k, s.path, d)),
        alwaysSet: d in s.data
      });
    }
    if (this._def.catchall instanceof V) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const p of o)
          u.push({
            key: { status: "valid", value: p },
            value: { status: "valid", value: s.data[p] }
          });
      else if (d === "strict")
        o.length > 0 && (f(s, {
          code: l.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (d !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const p of o) {
        const k = s.data[p];
        u.push({
          key: { status: "valid", value: p },
          value: d._parse(
            new D(s, k, s.path, p)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: p in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const p of u) {
        const k = await p.key, x = await p.value;
        d.push({
          key: k,
          value: x,
          alwaysSet: p.alwaysSet
        });
      }
      return d;
    }).then((d) => O.mergeObjectSync(n, d)) : O.mergeObjectSync(n, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return m.errToObj, new T({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, n) => {
          var a, i;
          const s = ((i = (a = this._def).errorMap) == null ? void 0 : i.call(a, t, n).message) ?? n.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: m.errToObj(e).message ?? s
          } : {
            message: s
          };
        }
      } : {}
    });
  }
  strip() {
    return new T({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new T({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new T({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new T({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: y.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new T({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    for (const n of b.objectKeys(e))
      e[n] && this.shape[n] && (t[n] = this.shape[n]);
    return new T({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    for (const n of b.objectKeys(this.shape))
      e[n] || (t[n] = this.shape[n]);
    return new T({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return te(this);
  }
  partial(e) {
    const t = {};
    for (const n of b.objectKeys(this.shape)) {
      const s = this.shape[n];
      e && !e[n] ? t[n] = s : t[n] = s.optional();
    }
    return new T({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    for (const n of b.objectKeys(this.shape))
      if (e && !e[n])
        t[n] = this.shape[n];
      else {
        let a = this.shape[n];
        for (; a instanceof Z; )
          a = a._def.innerType;
        t[n] = a;
      }
    return new T({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return ot(b.objectKeys(this.shape));
  }
}
T.create = (r, e) => new T({
  shape: () => r,
  unknownKeys: "strip",
  catchall: V.create(),
  typeName: y.ZodObject,
  ...v(e)
});
T.strictCreate = (r, e) => new T({
  shape: () => r,
  unknownKeys: "strict",
  catchall: V.create(),
  typeName: y.ZodObject,
  ...v(e)
});
T.lazycreate = (r, e) => new T({
  shape: r,
  unknownKeys: "strip",
  catchall: V.create(),
  typeName: y.ZodObject,
  ...v(e)
});
class he extends _ {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), n = this._def.options;
    function s(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return t.common.issues.push(...o.ctx.common.issues), o.result;
      const i = a.map((o) => new C(o.ctx.common.issues));
      return f(t, {
        code: l.invalid_union,
        unionErrors: i
      }), g;
    }
    if (t.common.async)
      return Promise.all(n.map(async (a) => {
        const i = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: t.data,
            path: t.path,
            parent: i
          }),
          ctx: i
        };
      })).then(s);
    {
      let a;
      const i = [];
      for (const u of n) {
        const d = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, p = u._parseSync({
          data: t.data,
          path: t.path,
          parent: d
        });
        if (p.status === "valid")
          return p;
        p.status === "dirty" && !a && (a = { result: p, ctx: d }), d.common.issues.length && i.push(d.common.issues);
      }
      if (a)
        return t.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((u) => new C(u));
      return f(t, {
        code: l.invalid_union,
        unionErrors: o
      }), g;
    }
  }
  get options() {
    return this._def.options;
  }
}
he.create = (r, e) => new he({
  options: r,
  typeName: y.ZodUnion,
  ...v(e)
});
const $ = (r) => r instanceof ge ? $(r.schema) : r instanceof R ? $(r.innerType()) : r instanceof ye ? [r.value] : r instanceof B ? r.options : r instanceof ve ? b.objectValues(r.enum) : r instanceof _e ? $(r._def.innerType) : r instanceof le ? [void 0] : r instanceof fe ? [null] : r instanceof Z ? [void 0, ...$(r.unwrap())] : r instanceof U ? [null, ...$(r.unwrap())] : r instanceof qe || r instanceof xe ? $(r.unwrap()) : r instanceof be ? $(r._def.innerType) : [];
class Pe extends _ {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== h.object)
      return f(t, {
        code: l.invalid_type,
        expected: h.object,
        received: t.parsedType
      }), g;
    const n = this.discriminator, s = t.data[n], a = this.optionsMap.get(s);
    return a ? t.common.async ? a._parseAsync({
      data: t.data,
      path: t.path,
      parent: t
    }) : a._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }) : (f(t, {
      code: l.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), g);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, t, n) {
    const s = /* @__PURE__ */ new Map();
    for (const a of t) {
      const i = $(a.shape[e]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (s.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        s.set(o, a);
      }
    }
    return new Pe({
      typeName: y.ZodDiscriminatedUnion,
      discriminator: e,
      options: t,
      optionsMap: s,
      ...v(n)
    });
  }
}
function Ve(r, e) {
  const t = W(r), n = W(e);
  if (r === e)
    return { valid: !0, data: r };
  if (t === h.object && n === h.object) {
    const s = b.objectKeys(e), a = b.objectKeys(r).filter((o) => s.indexOf(o) !== -1), i = { ...r, ...e };
    for (const o of a) {
      const u = Ve(r[o], e[o]);
      if (!u.valid)
        return { valid: !1 };
      i[o] = u.data;
    }
    return { valid: !0, data: i };
  } else if (t === h.array && n === h.array) {
    if (r.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let a = 0; a < r.length; a++) {
      const i = r[a], o = e[a], u = Ve(i, o);
      if (!u.valid)
        return { valid: !1 };
      s.push(u.data);
    }
    return { valid: !0, data: s };
  } else return t === h.date && n === h.date && +r == +e ? { valid: !0, data: r } : { valid: !1 };
}
class me extends _ {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e), s = (a, i) => {
      if ($e(a) || $e(i))
        return g;
      const o = Ve(a.value, i.value);
      return o.valid ? ((We(a) || We(i)) && t.dirty(), { status: t.value, value: o.data }) : (f(n, {
        code: l.invalid_intersection_types
      }), g);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, i]) => s(a, i)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
me.create = (r, e, t) => new me({
  left: r,
  right: e,
  typeName: y.ZodIntersection,
  ...v(t)
});
class L extends _ {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.array)
      return f(n, {
        code: l.invalid_type,
        expected: h.array,
        received: n.parsedType
      }), g;
    if (n.data.length < this._def.items.length)
      return f(n, {
        code: l.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), g;
    !this._def.rest && n.data.length > this._def.items.length && (f(n, {
      code: l.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const a = [...n.data].map((i, o) => {
      const u = this._def.items[o] || this._def.rest;
      return u ? u._parse(new D(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(a).then((i) => O.mergeArray(t, i)) : O.mergeArray(t, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new L({
      ...this._def,
      rest: e
    });
  }
}
L.create = (r, e) => {
  if (!Array.isArray(r))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new L({
    items: r,
    typeName: y.ZodTuple,
    rest: null,
    ...v(e)
  });
};
class pe extends _ {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.object)
      return f(n, {
        code: l.invalid_type,
        expected: h.object,
        received: n.parsedType
      }), g;
    const s = [], a = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      s.push({
        key: a._parse(new D(n, o, n.path, o)),
        value: i._parse(new D(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? O.mergeObjectAsync(t, s) : O.mergeObjectSync(t, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, t, n) {
    return t instanceof _ ? new pe({
      keyType: e,
      valueType: t,
      typeName: y.ZodRecord,
      ...v(n)
    }) : new pe({
      keyType: E.create(),
      valueType: e,
      typeName: y.ZodRecord,
      ...v(t)
    });
  }
}
class Ce extends _ {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.map)
      return f(n, {
        code: l.invalid_type,
        expected: h.map,
        received: n.parsedType
      }), g;
    const s = this._def.keyType, a = this._def.valueType, i = [...n.data.entries()].map(([o, u], d) => ({
      key: s._parse(new D(n, o, n.path, [d, "key"])),
      value: a._parse(new D(n, u, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of i) {
          const d = await u.key, p = await u.value;
          if (d.status === "aborted" || p.status === "aborted")
            return g;
          (d.status === "dirty" || p.status === "dirty") && t.dirty(), o.set(d.value, p.value);
        }
        return { status: t.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const u of i) {
        const d = u.key, p = u.value;
        if (d.status === "aborted" || p.status === "aborted")
          return g;
        (d.status === "dirty" || p.status === "dirty") && t.dirty(), o.set(d.value, p.value);
      }
      return { status: t.value, value: o };
    }
  }
}
Ce.create = (r, e, t) => new Ce({
  valueType: e,
  keyType: r,
  typeName: y.ZodMap,
  ...v(t)
});
class K extends _ {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.set)
      return f(n, {
        code: l.invalid_type,
        expected: h.set,
        received: n.parsedType
      }), g;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (f(n, {
      code: l.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), t.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (f(n, {
      code: l.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), t.dirty());
    const a = this._def.valueType;
    function i(u) {
      const d = /* @__PURE__ */ new Set();
      for (const p of u) {
        if (p.status === "aborted")
          return g;
        p.status === "dirty" && t.dirty(), d.add(p.value);
      }
      return { status: t.value, value: d };
    }
    const o = [...n.data.values()].map((u, d) => a._parse(new D(n, u, n.path, d)));
    return n.common.async ? Promise.all(o).then((u) => i(u)) : i(o);
  }
  min(e, t) {
    return new K({
      ...this._def,
      minSize: { value: e, message: m.toString(t) }
    });
  }
  max(e, t) {
    return new K({
      ...this._def,
      maxSize: { value: e, message: m.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
K.create = (r, e) => new K({
  valueType: r,
  minSize: null,
  maxSize: null,
  typeName: y.ZodSet,
  ...v(e)
});
class ne extends _ {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== h.function)
      return f(t, {
        code: l.invalid_type,
        expected: h.function,
        received: t.parsedType
      }), g;
    function n(o, u) {
      return Me({
        data: o,
        path: t.path,
        errorMaps: [t.common.contextualErrorMap, t.schemaErrorMap, Oe(), ae].filter((d) => !!d),
        issueData: {
          code: l.invalid_arguments,
          argumentsError: u
        }
      });
    }
    function s(o, u) {
      return Me({
        data: o,
        path: t.path,
        errorMaps: [t.common.contextualErrorMap, t.schemaErrorMap, Oe(), ae].filter((d) => !!d),
        issueData: {
          code: l.invalid_return_type,
          returnTypeError: u
        }
      });
    }
    const a = { errorMap: t.common.contextualErrorMap }, i = t.data;
    if (this._def.returns instanceof ie) {
      const o = this;
      return M(async function(...u) {
        const d = new C([]), p = await o._def.args.parseAsync(u, a).catch((I) => {
          throw d.addIssue(n(u, I)), d;
        }), k = await Reflect.apply(i, this, p);
        return await o._def.returns._def.type.parseAsync(k, a).catch((I) => {
          throw d.addIssue(s(k, I)), d;
        });
      });
    } else {
      const o = this;
      return M(function(...u) {
        const d = o._def.args.safeParse(u, a);
        if (!d.success)
          throw new C([n(u, d.error)]);
        const p = Reflect.apply(i, this, d.data), k = o._def.returns.safeParse(p, a);
        if (!k.success)
          throw new C([s(p, k.error)]);
        return k.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ne({
      ...this._def,
      args: L.create(e).rest(Q.create())
    });
  }
  returns(e) {
    return new ne({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, t, n) {
    return new ne({
      args: e || L.create([]).rest(Q.create()),
      returns: t || Q.create(),
      typeName: y.ZodFunction,
      ...v(n)
    });
  }
}
class ge extends _ {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
ge.create = (r, e) => new ge({
  getter: r,
  typeName: y.ZodLazy,
  ...v(e)
});
class ye extends _ {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return f(t, {
        received: t.data,
        code: l.invalid_literal,
        expected: this._def.value
      }), g;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
ye.create = (r, e) => new ye({
  value: r,
  typeName: y.ZodLiteral,
  ...v(e)
});
function ot(r, e) {
  return new B({
    values: r,
    typeName: y.ZodEnum,
    ...v(e)
  });
}
class B extends _ {
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), n = this._def.values;
      return f(t, {
        expected: b.joinValues(n),
        received: t.parsedType,
        code: l.invalid_type
      }), g;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const t = this._getOrReturnCtx(e), n = this._def.values;
      return f(t, {
        received: t.data,
        code: l.invalid_enum_value,
        options: n
      }), g;
    }
    return M(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return B.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return B.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...t
    });
  }
}
B.create = ot;
class ve extends _ {
  _parse(e) {
    const t = b.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== h.string && n.parsedType !== h.number) {
      const s = b.objectValues(t);
      return f(n, {
        expected: b.joinValues(s),
        received: n.parsedType,
        code: l.invalid_type
      }), g;
    }
    if (this._cache || (this._cache = new Set(b.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const s = b.objectValues(t);
      return f(n, {
        received: n.data,
        code: l.invalid_enum_value,
        options: s
      }), g;
    }
    return M(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
ve.create = (r, e) => new ve({
  values: r,
  typeName: y.ZodNativeEnum,
  ...v(e)
});
class ie extends _ {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== h.promise && t.common.async === !1)
      return f(t, {
        code: l.invalid_type,
        expected: h.promise,
        received: t.parsedType
      }), g;
    const n = t.parsedType === h.promise ? t.data : Promise.resolve(t.data);
    return M(n.then((s) => this._def.type.parseAsync(s, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
ie.create = (r, e) => new ie({
  type: r,
  typeName: y.ZodPromise,
  ...v(e)
});
class R extends _ {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === y.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e), s = this._def.effect || null, a = {
      addIssue: (i) => {
        f(n, i), i.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), s.type === "preprocess") {
      const i = s.transform(n.data, a);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (t.value === "aborted")
            return g;
          const u = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return u.status === "aborted" ? g : u.status === "dirty" || t.value === "dirty" ? re(u.value) : u;
        });
      {
        if (t.value === "aborted")
          return g;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? g : o.status === "dirty" || t.value === "dirty" ? re(o.value) : o;
      }
    }
    if (s.type === "refinement") {
      const i = (o) => {
        const u = s.refinement(o, a);
        if (n.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? g : (o.status === "dirty" && t.dirty(), i(o.value), { status: t.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? g : (o.status === "dirty" && t.dirty(), i(o.value).then(() => ({ status: t.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!G(i))
          return g;
        const o = s.transform(i.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => G(i) ? Promise.resolve(s.transform(i.value, a)).then((o) => ({
          status: t.value,
          value: o
        })) : g);
    b.assertNever(s);
  }
}
R.create = (r, e, t) => new R({
  schema: r,
  typeName: y.ZodEffects,
  effect: e,
  ...v(t)
});
R.createWithPreprocess = (r, e, t) => new R({
  schema: e,
  effect: { type: "preprocess", transform: r },
  typeName: y.ZodEffects,
  ...v(t)
});
class Z extends _ {
  _parse(e) {
    return this._getType(e) === h.undefined ? M(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Z.create = (r, e) => new Z({
  innerType: r,
  typeName: y.ZodOptional,
  ...v(e)
});
class U extends _ {
  _parse(e) {
    return this._getType(e) === h.null ? M(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
U.create = (r, e) => new U({
  innerType: r,
  typeName: y.ZodNullable,
  ...v(e)
});
class _e extends _ {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let n = t.data;
    return t.parsedType === h.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
_e.create = (r, e) => new _e({
  innerType: r,
  typeName: y.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...v(e)
});
class be extends _ {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), n = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return ue(s) ? s.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new C(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new C(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
be.create = (r, e) => new be({
  innerType: r,
  typeName: y.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...v(e)
});
class Ne extends _ {
  _parse(e) {
    if (this._getType(e) !== h.nan) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: l.invalid_type,
        expected: h.nan,
        received: n.parsedType
      }), g;
    }
    return { status: "valid", value: e.data };
  }
}
Ne.create = (r) => new Ne({
  typeName: y.ZodNaN,
  ...v(r)
});
const dr = Symbol("zod_brand");
class qe extends _ {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), n = t.data;
    return this._def.type._parse({
      data: n,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class we extends _ {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return a.status === "aborted" ? g : a.status === "dirty" ? (t.dirty(), re(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? g : s.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, t) {
    return new we({
      in: e,
      out: t,
      typeName: y.ZodPipeline
    });
  }
}
class xe extends _ {
  _parse(e) {
    const t = this._def.innerType._parse(e), n = (s) => (G(s) && (s.value = Object.freeze(s.value)), s);
    return ue(t) ? t.then((s) => n(s)) : n(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
xe.create = (r, e) => new xe({
  innerType: r,
  typeName: y.ZodReadonly,
  ...v(e)
});
function He(r, e) {
  const t = typeof r == "function" ? r(e) : typeof r == "string" ? { message: r } : r;
  return typeof t == "string" ? { message: t } : t;
}
function ct(r, e = {}, t) {
  return r ? se.create().superRefine((n, s) => {
    const a = r(n);
    if (a instanceof Promise)
      return a.then((i) => {
        if (!i) {
          const o = He(e, n), u = o.fatal ?? t ?? !0;
          s.addIssue({ code: "custom", ...o, fatal: u });
        }
      });
    if (!a) {
      const i = He(e, n), o = i.fatal ?? t ?? !0;
      s.addIssue({ code: "custom", ...i, fatal: o });
    }
  }) : se.create();
}
const lr = {
  object: T.lazycreate
};
var y;
(function(r) {
  r.ZodString = "ZodString", r.ZodNumber = "ZodNumber", r.ZodNaN = "ZodNaN", r.ZodBigInt = "ZodBigInt", r.ZodBoolean = "ZodBoolean", r.ZodDate = "ZodDate", r.ZodSymbol = "ZodSymbol", r.ZodUndefined = "ZodUndefined", r.ZodNull = "ZodNull", r.ZodAny = "ZodAny", r.ZodUnknown = "ZodUnknown", r.ZodNever = "ZodNever", r.ZodVoid = "ZodVoid", r.ZodArray = "ZodArray", r.ZodObject = "ZodObject", r.ZodUnion = "ZodUnion", r.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", r.ZodIntersection = "ZodIntersection", r.ZodTuple = "ZodTuple", r.ZodRecord = "ZodRecord", r.ZodMap = "ZodMap", r.ZodSet = "ZodSet", r.ZodFunction = "ZodFunction", r.ZodLazy = "ZodLazy", r.ZodLiteral = "ZodLiteral", r.ZodEnum = "ZodEnum", r.ZodEffects = "ZodEffects", r.ZodNativeEnum = "ZodNativeEnum", r.ZodOptional = "ZodOptional", r.ZodNullable = "ZodNullable", r.ZodDefault = "ZodDefault", r.ZodCatch = "ZodCatch", r.ZodPromise = "ZodPromise", r.ZodBranded = "ZodBranded", r.ZodPipeline = "ZodPipeline", r.ZodReadonly = "ZodReadonly";
})(y || (y = {}));
const fr = (r, e = {
  message: `Input not instance of ${r.name}`
}) => ct((t) => t instanceof r, e), ut = E.create, dt = F.create, hr = Ne.create, mr = q.create, lt = de.create, pr = X.create, gr = Ae.create, yr = le.create, vr = fe.create, _r = se.create, br = Q.create, xr = V.create, wr = je.create, kr = P.create, Tr = T.create, Sr = T.strictCreate, Or = he.create, Mr = Pe.create, Ar = me.create, jr = L.create, Cr = pe.create, Nr = Ce.create, Er = K.create, Pr = ne.create, Rr = ge.create, Ir = ye.create, Zr = B.create, Dr = ve.create, Lr = ie.create, Qe = R.create, $r = Z.create, Wr = U.create, Vr = R.createWithPreprocess, zr = we.create, Fr = () => ut().optional(), qr = () => dt().optional(), Br = () => lt().optional(), Ur = {
  string: (r) => E.create({ ...r, coerce: !0 }),
  number: (r) => F.create({ ...r, coerce: !0 }),
  boolean: (r) => de.create({
    ...r,
    coerce: !0
  }),
  bigint: (r) => q.create({ ...r, coerce: !0 }),
  date: (r) => X.create({ ...r, coerce: !0 })
}, Jr = g, c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BRAND: dr,
  DIRTY: re,
  EMPTY_PATH: zt,
  INVALID: g,
  NEVER: Jr,
  OK: M,
  ParseStatus: O,
  Schema: _,
  ZodAny: se,
  ZodArray: P,
  ZodBigInt: q,
  ZodBoolean: de,
  ZodBranded: qe,
  ZodCatch: be,
  ZodDate: X,
  ZodDefault: _e,
  ZodDiscriminatedUnion: Pe,
  ZodEffects: R,
  ZodEnum: B,
  ZodError: C,
  get ZodFirstPartyTypeKind() {
    return y;
  },
  ZodFunction: ne,
  ZodIntersection: me,
  ZodIssueCode: l,
  ZodLazy: ge,
  ZodLiteral: ye,
  ZodMap: Ce,
  ZodNaN: Ne,
  ZodNativeEnum: ve,
  ZodNever: V,
  ZodNull: fe,
  ZodNullable: U,
  ZodNumber: F,
  ZodObject: T,
  ZodOptional: Z,
  ZodParsedType: h,
  ZodPipeline: we,
  ZodPromise: ie,
  ZodReadonly: xe,
  ZodRecord: pe,
  ZodSchema: _,
  ZodSet: K,
  ZodString: E,
  ZodSymbol: Ae,
  ZodTransformer: R,
  ZodTuple: L,
  ZodType: _,
  ZodUndefined: le,
  ZodUnion: he,
  ZodUnknown: Q,
  ZodVoid: je,
  addIssueToContext: f,
  any: _r,
  array: kr,
  bigint: mr,
  boolean: lt,
  coerce: Ur,
  custom: ct,
  date: pr,
  datetimeRegex: it,
  defaultErrorMap: ae,
  discriminatedUnion: Mr,
  effect: Qe,
  enum: Zr,
  function: Pr,
  getErrorMap: Oe,
  getParsedType: W,
  instanceof: fr,
  intersection: Ar,
  isAborted: $e,
  isAsync: ue,
  isDirty: We,
  isValid: G,
  late: lr,
  lazy: Rr,
  literal: Ir,
  makeIssue: Me,
  map: Nr,
  nan: hr,
  nativeEnum: Dr,
  never: xr,
  null: vr,
  nullable: Wr,
  number: dt,
  object: Tr,
  get objectUtil() {
    return Le;
  },
  oboolean: Br,
  onumber: qr,
  optional: $r,
  ostring: Fr,
  pipeline: zr,
  preprocess: Vr,
  promise: Lr,
  quotelessJson: Wt,
  record: Cr,
  set: Er,
  setErrorMap: Vt,
  strictObject: Sr,
  string: ut,
  symbol: gr,
  transformer: Qe,
  tuple: jr,
  undefined: yr,
  union: Or,
  unknown: br,
  get util() {
    return b;
  },
  void: wr
}, Symbol.toStringTag, { value: "Module" })), Yr = c.object({
  role: c.literal("system"),
  content: c.string(),
  providerOptions: c.record(c.string(), c.any()).optional()
}), Hr = c.object({
  type: c.literal("text"),
  text: c.string(),
  providerOptions: c.record(c.string(), c.any()).optional()
}), Qr = c.object({
  type: c.literal("image"),
  imageUrl: c.string(),
  mimeType: c.string().optional(),
  providerOptions: c.record(c.string(), c.any()).optional()
}), Gr = c.object({
  type: c.literal("file"),
  fileUrl: c.string(),
  filename: c.string().optional(),
  mimeType: c.string(),
  providerOptions: c.record(c.string(), c.any()).optional()
}), Xr = c.union([
  Hr,
  Qr,
  Gr
]), Kr = c.object({
  role: c.literal("user"),
  content: c.union([c.string(), c.array(Xr)]),
  providerOptions: c.record(c.string(), c.any()).optional()
}), Ge = c.union([Yr, Kr]), en = c.discriminatedUnion("type", [
  c.object({
    description: c.string().optional(),
    parameters: c.any(),
    type: c.literal("function")
  }),
  c.object({
    type: c.literal("provider-defined"),
    parameters: c.any(),
    id: c.string().regex(/^[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+$/),
    args: c.record(c.string(), c.unknown())
  })
]), tn = c.object({
  model: c.enum([
    "o3",
    "o4-mini",
    "gpt-4.1",
    "gpt-4.1-mini",
    "gpt-4.1-nano",
    "gpt-4o",
    "gpt-4o-mini"
  ])
}), rn = c.object({
  model: c.enum([
    "claude-opus-4-0",
    "claude-sonnet-4-0",
    "claude-3-7-sonnet-latest",
    "claude-3-5-haiku-latest"
  ])
}), nn = c.object({
  model: c.enum([
    "ministral-3b-latest",
    "ministral-8b-latest",
    "mistral-large-latest",
    "mistral-small-latest",
    "pixtral-large-latest",
    "pixtral-12b-latest"
  ])
}), an = c.object({
  model: c.enum([
    "command-a-03-2025",
    "command-r7b-12-2024",
    "command-r-plus",
    "command-r",
    "command"
  ])
}), sn = c.object({
  model: c.enum([
    "gemini-2.0-flash",
    "gemini-2.0-flash-lite",
    "gemini-2.5-flash-preview-05-20",
    "gemini-2.5-pro-preview-05-06"
  ])
}), on = c.object({
  model: c.enum(["text-embedding-3-small", "text-embedding-3-large"])
}), cn = c.object({
  model: c.never()
}), un = c.object({
  model: c.enum(["mistral-embed"])
}), dn = c.object({
  model: c.enum([
    "embed-english-v3.0",
    "embed-multilingual-v3.0",
    "embed-english-light-v3.0",
    "embed-multilingual-light-v3.0"
  ])
}), ln = c.object({
  model: c.enum(["text-embedding-004"])
}), ft = c.object({
  provider: c.literal("openai")
}), ht = c.object({
  provider: c.literal("anthropic")
}), mt = c.object({
  provider: c.literal("mistral")
}), pt = c.object({
  provider: c.literal("cohere")
}), gt = c.object({
  provider: c.literal("google")
}), Te = c.object({
  apiKey: c.string(),
  temperature: c.number().optional()
}), fn = c.object({
  operation: c.literal("generateText")
}), hn = c.object({
  operation: c.literal("generateObject")
}), mn = c.object({
  operation: c.literal("streamText")
}), pn = c.object({
  operation: c.literal("embed")
}), De = c.object({
  model: c.discriminatedUnion("provider", [
    ft.merge(tn),
    ht.merge(rn),
    mt.merge(nn),
    pt.merge(an),
    gt.merge(sn)
  ])
}), gn = c.object({
  model: c.discriminatedUnion("provider", [
    ft.merge(on),
    ht.merge(cn),
    mt.merge(un),
    pt.merge(dn),
    gt.merge(ln)
  ])
}), ea = c.discriminatedUnion("operation", [
  hn.merge(Te).merge(De).extend({
    prompt: c.string(),
    schema: c.any().describe("jsOnly")
  }),
  fn.merge(Te).merge(De).extend({
    messages: c.array(Ge).optional().describe("jsOnly"),
    system: c.string().optional(),
    prompt: c.string().optional(),
    tools: c.record(c.string(), en).describe("jsOnly"),
    toolChoice: c.enum(["auto", "required", "none"]).optional()
  }),
  mn.merge(Te).merge(De).extend({
    messages: c.array(Ge).optional().describe("jsOnly"),
    system: c.string().optional(),
    prompt: c.string().optional()
  }),
  pn.merge(Te).merge(gn).extend({
    value: c.string()
  })
]);
c.discriminatedUnion("type", [
  c.object({
    type: c.literal("result"),
    value: c.object({
      reasoning: c.string().optional(),
      text: c.string(),
      toolCalls: c.array(c.object({
        type: c.enum(["function", "tool-call"]),
        toolName: c.string(),
        toolCallId: c.string(),
        id: c.string().optional(),
        args: c.any()
      }))
    })
  }),
  c.object({
    type: c.literal("objectResult"),
    value: c.any()
  }),
  c.object({
    type: c.literal("streamChunk"),
    value: c.string()
  }),
  c.object({
    type: c.literal("streamResult"),
    value: c.object({
      text: c.string()
    })
  }),
  c.object({
    type: c.literal("embeddingResult"),
    value: c.array(c.number())
  }),
  c.object({
    type: c.literal("error"),
    error: c.string()
  })
]);
const Xe = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, yn = (r, e, t) => {
  let n;
  const s = t != null && t.addSuffix ? Xe[r].withPreposition : Xe[r].standalone;
  return typeof s == "string" ? n = s : e === 1 ? n = s.one : n = s.other.replace("{{count}}", String(e)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : "vor " + n : n;
}, vn = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, _n = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, bn = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, xn = {
  date: Ie({
    formats: vn,
    defaultWidth: "full"
  }),
  time: Ie({
    formats: _n,
    defaultWidth: "full"
  }),
  dateTime: Ie({
    formats: bn,
    defaultWidth: "full"
  })
}, wn = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, kn = (r, e, t, n) => wn[r], Tn = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, Sn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, ze = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, On = {
  narrow: ze.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: ze.wide
}, Mn = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, An = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, jn = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, Cn = (r) => Number(r) + ".", Nn = {
  ordinalNumber: Cn,
  era: oe({
    values: Tn,
    defaultWidth: "wide"
  }),
  quarter: oe({
    values: Sn,
    defaultWidth: "wide",
    argumentCallback: (r) => r - 1
  }),
  month: oe({
    values: ze,
    formattingValues: On,
    defaultWidth: "wide"
  }),
  day: oe({
    values: Mn,
    defaultWidth: "wide"
  }),
  dayPeriod: oe({
    values: An,
    defaultWidth: "wide",
    formattingValues: jn,
    defaultFormattingWidth: "wide"
  })
}, En = /^(\d+)(\.)?/i, Pn = /\d+/i, Rn = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, In = {
  any: [/^v/i, /^n/i]
}, Zn = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, Dn = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ln = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, $n = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Wn = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, Vn = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, zn = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, Fn = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, qn = {
  ordinalNumber: vt({
    matchPattern: En,
    parsePattern: Pn,
    valueCallback: (r) => parseInt(r)
  }),
  era: ce({
    matchPatterns: Rn,
    defaultMatchWidth: "wide",
    parsePatterns: In,
    defaultParseWidth: "any"
  }),
  quarter: ce({
    matchPatterns: Zn,
    defaultMatchWidth: "wide",
    parsePatterns: Dn,
    defaultParseWidth: "any",
    valueCallback: (r) => r + 1
  }),
  month: ce({
    matchPatterns: Ln,
    defaultMatchWidth: "wide",
    parsePatterns: $n,
    defaultParseWidth: "any"
  }),
  day: ce({
    matchPatterns: Wn,
    defaultMatchWidth: "wide",
    parsePatterns: Vn,
    defaultParseWidth: "any"
  }),
  dayPeriod: ce({
    matchPatterns: zn,
    defaultMatchWidth: "wide",
    parsePatterns: Fn,
    defaultParseWidth: "any"
  })
}, Bn = {
  code: "de",
  formatDistance: yn,
  formatLong: xn,
  formatRelative: kn,
  localize: Nn,
  match: qn,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var Se = { exports: {} }, Un = Se.exports, Ke;
function Jn() {
  return Ke || (Ke = 1, function(r, e) {
    (function(t, n) {
      r.exports = n();
    })(Un, function() {
      Array.isArray || (Array.isArray = function(a) {
        return Object.prototype.toString.call(a) === "[object Array]";
      });
      function t(a) {
        for (var i = [], o = 0, u = a.length; o < u; o++)
          i.indexOf(a[o]) === -1 && i.push(a[o]);
        return i;
      }
      var n = {}, s = {
        "==": function(a, i) {
          return a == i;
        },
        "===": function(a, i) {
          return a === i;
        },
        "!=": function(a, i) {
          return a != i;
        },
        "!==": function(a, i) {
          return a !== i;
        },
        ">": function(a, i) {
          return a > i;
        },
        ">=": function(a, i) {
          return a >= i;
        },
        "<": function(a, i, o) {
          return o === void 0 ? a < i : a < i && i < o;
        },
        "<=": function(a, i, o) {
          return o === void 0 ? a <= i : a <= i && i <= o;
        },
        "!!": function(a) {
          return n.truthy(a);
        },
        "!": function(a) {
          return !n.truthy(a);
        },
        "%": function(a, i) {
          return a % i;
        },
        log: function(a) {
          return console.log(a), a;
        },
        in: function(a, i) {
          return !i || typeof i.indexOf > "u" ? !1 : i.indexOf(a) !== -1;
        },
        cat: function() {
          return Array.prototype.join.call(arguments, "");
        },
        substr: function(a, i, o) {
          if (o < 0) {
            var u = String(a).substr(i);
            return u.substr(0, u.length + o);
          }
          return String(a).substr(i, o);
        },
        "+": function() {
          return Array.prototype.reduce.call(arguments, function(a, i) {
            return parseFloat(a, 10) + parseFloat(i, 10);
          }, 0);
        },
        "*": function() {
          return Array.prototype.reduce.call(arguments, function(a, i) {
            return parseFloat(a, 10) * parseFloat(i, 10);
          });
        },
        "-": function(a, i) {
          return i === void 0 ? -a : a - i;
        },
        "/": function(a, i) {
          return a / i;
        },
        min: function() {
          return Math.min.apply(this, arguments);
        },
        max: function() {
          return Math.max.apply(this, arguments);
        },
        merge: function() {
          return Array.prototype.reduce.call(arguments, function(a, i) {
            return a.concat(i);
          }, []);
        },
        var: function(a, i) {
          var o = i === void 0 ? null : i, u = this;
          if (typeof a > "u" || a === "" || a === null)
            return u;
          for (var d = String(a).split("."), p = 0; p < d.length; p++)
            if (u == null || (u = u[d[p]], u === void 0))
              return o;
          return u;
        },
        missing: function() {
          for (var a = [], i = Array.isArray(arguments[0]) ? arguments[0] : arguments, o = 0; o < i.length; o++) {
            var u = i[o], d = n.apply({ var: u }, this);
            (d === null || d === "") && a.push(u);
          }
          return a;
        },
        missing_some: function(a, i) {
          var o = n.apply({ missing: i }, this);
          return i.length - o.length >= a ? [] : o;
        }
      };
      return n.is_logic = function(a) {
        return typeof a == "object" && // An object
        a !== null && // but not null
        !Array.isArray(a) && // and not an array
        Object.keys(a).length === 1;
      }, n.truthy = function(a) {
        return Array.isArray(a) && a.length === 0 ? !1 : !!a;
      }, n.get_operator = function(a) {
        return Object.keys(a)[0];
      }, n.get_values = function(a) {
        return a[n.get_operator(a)];
      }, n.apply = function(a, i) {
        if (Array.isArray(a))
          return a.map(function(N) {
            return n.apply(N, i);
          });
        if (!n.is_logic(a))
          return a;
        var o = n.get_operator(a), u = a[o], d, p, k, x, I;
        if (Array.isArray(u) || (u = [u]), o === "if" || o == "?:") {
          for (d = 0; d < u.length - 1; d += 2)
            if (n.truthy(n.apply(u[d], i)))
              return n.apply(u[d + 1], i);
          return u.length === d + 1 ? n.apply(u[d], i) : null;
        } else if (o === "and") {
          for (d = 0; d < u.length; d += 1)
            if (p = n.apply(u[d], i), !n.truthy(p))
              return p;
          return p;
        } else if (o === "or") {
          for (d = 0; d < u.length; d += 1)
            if (p = n.apply(u[d], i), n.truthy(p))
              return p;
          return p;
        } else {
          if (o === "filter")
            return x = n.apply(u[0], i), k = u[1], Array.isArray(x) ? x.filter(function(N) {
              return n.truthy(n.apply(k, N));
            }) : [];
          if (o === "map")
            return x = n.apply(u[0], i), k = u[1], Array.isArray(x) ? x.map(function(N) {
              return n.apply(k, N);
            }) : [];
          if (o === "reduce")
            return x = n.apply(u[0], i), k = u[1], I = typeof u[2] < "u" ? n.apply(u[2], i) : null, Array.isArray(x) ? x.reduce(
              function(N, ke) {
                return n.apply(
                  k,
                  { current: ke, accumulator: N }
                );
              },
              I
            ) : I;
          if (o === "all") {
            if (x = n.apply(u[0], i), k = u[1], !Array.isArray(x) || !x.length)
              return !1;
            for (d = 0; d < x.length; d += 1)
              if (!n.truthy(n.apply(k, x[d])))
                return !1;
            return !0;
          } else if (o === "none") {
            if (x = n.apply(u[0], i), k = u[1], !Array.isArray(x) || !x.length)
              return !0;
            for (d = 0; d < x.length; d += 1)
              if (n.truthy(n.apply(k, x[d])))
                return !1;
            return !0;
          } else if (o === "some") {
            if (x = n.apply(u[0], i), k = u[1], !Array.isArray(x) || !x.length)
              return !1;
            for (d = 0; d < x.length; d += 1)
              if (n.truthy(n.apply(k, x[d])))
                return !0;
            return !1;
          }
        }
        if (u = u.map(function(N) {
          return n.apply(N, i);
        }), s.hasOwnProperty(o) && typeof s[o] == "function")
          return s[o].apply(i, u);
        if (o.indexOf(".") > 0) {
          var J = String(o).split("."), Y = s;
          for (d = 0; d < J.length; d++) {
            if (!Y.hasOwnProperty(J[d]))
              throw new Error("Unrecognized operation " + o + " (failed at " + J.slice(0, d + 1).join(".") + ")");
            Y = Y[J[d]];
          }
          return Y.apply(i, u);
        }
        throw new Error("Unrecognized operation " + o);
      }, n.uses_data = function(a) {
        var i = [];
        if (n.is_logic(a)) {
          var o = n.get_operator(a), u = a[o];
          Array.isArray(u) || (u = [u]), o === "var" ? i.push(u[0]) : u.forEach(function(d) {
            i.push.apply(i, n.uses_data(d));
          });
        }
        return t(i);
      }, n.add_operation = function(a, i) {
        s[a] = i;
      }, n.rm_operation = function(a) {
        delete s[a];
      }, n.rule_like = function(a, i) {
        if (i === a || i === "@")
          return !0;
        if (i === "number")
          return typeof a == "number";
        if (i === "string")
          return typeof a == "string";
        if (i === "array")
          return Array.isArray(a) && !n.is_logic(a);
        if (n.is_logic(i)) {
          if (n.is_logic(a)) {
            var o = n.get_operator(i), u = n.get_operator(a);
            if (o === "@" || o === u)
              return n.rule_like(
                n.get_values(a, !1),
                n.get_values(i, !1)
              );
          }
          return !1;
        }
        if (Array.isArray(i))
          if (Array.isArray(a)) {
            if (i.length !== a.length)
              return !1;
            for (var d = 0; d < i.length; d += 1)
              if (!n.rule_like(a[d], i[d]))
                return !1;
            return !0;
          } else
            return !1;
        return !1;
      }, n;
    });
  }(Se)), Se.exports;
}
var S = Jn();
const Yn = {
  "en-US": Fe,
  "de-DE": Bn
};
S.add_operation("object", function(...r) {
  return r.reduce((e, [t, n]) => (e[t] = n, e), {});
});
S.add_operation("Object.fromEntries", function(...r) {
  return Object.fromEntries(r);
});
S.add_operation("Object.entries", function(r) {
  return Object.entries(r);
});
S.add_operation("Object.values", function(r) {
  return Object.values(r);
});
S.add_operation("Object.keys", function(r) {
  return Object.keys(r);
});
S.add_operation("reverse", function(r) {
  return [...r].reverse();
});
S.add_operation("Array.reverse", function(r) {
  return [...r].reverse();
});
S.add_operation("Array.extendEach", function(r, e) {
  return r.map((t) => ({ ...t, ...e }));
});
S.add_operation("jsonstringify", function(r) {
  return JSON.stringify(r);
});
S.add_operation("JSON.stringify", function(r) {
  return JSON.stringify(r);
});
S.add_operation("jsonparse", function(r) {
  return JSON.parse(r);
});
S.add_operation("JSON.parse", function(r) {
  return JSON.parse(r);
});
S.add_operation("join", function(r, ...e) {
  return e.join(r);
});
S.add_operation("Array.join", function(r, e) {
  return r.join(e);
});
S.add_operation("get", function(r, e) {
  return rt(r, e);
});
S.add_operation("lodash.get", function(r, e) {
  return rt(r, e);
});
S.add_operation("Date.now", function() {
  return Date.now();
});
S.add_operation("Date.format", function(r, e, t) {
  const n = Yn[t] ?? Fe;
  try {
    return Lt(r, e, { locale: n });
  } catch {
    return "";
  }
});
S.add_operation("String.replaceAllBasedOnMap", function(r, e, t) {
  let n = r;
  return Object.keys(e).forEach((s) => {
    const a = S.apply(e[s], t);
    n = n.replaceAll(s, a);
  }), n;
});
S.add_operation("Number.format", function(r, e, t) {
  const n = e ?? "en-US";
  return new Intl.NumberFormat(n, {
    maximumFractionDigits: t,
    minimumFractionDigits: t
  }).format(r);
});
const ta = (r, e) => S.apply(r, e);
var et;
(function(r) {
  r.TABLE_DATA_CHANGE = "TABLE_DATA_CHANGE", r.SCHEDULE = "SCHEDULE";
})(et || (et = {}));
var tt;
(function(r) {
  r.createType = "createType", r.updateType = "updateType", r.deleteType = "deleteType", r.openAICompletion = "openAICompletion", r.openAIEmbeddings = "openAIEmbeddings", r.type = "type", r.listType = "listType", r.listTypeByParent = "listTypeByParent", r.batchCreateType = "batchCreateType", r.notifyWebSocket = "notifyWebSocket", r.elevenLabsTTS = "elevenLabsTTS", r.logic = "logic", r.createFont = "createFont", r.htmlToPdf = "htmlToPdf", r.openAIImageGeneration = "openAIImageGeneration", r.batchGetType = "batchGetType", r.googleSearch = "googleSearch", r.linkScraper = "linkScraper", r.httpRequest = "httpRequest", r.extractImageMetadata = "extractImageMetadata", r.cloudFunction = "cloudFunction", r.genericAI = "genericAI";
})(tt || (tt = {}));
export {
  tt as S,
  et as T,
  ta as a,
  ea as g
};
